import styled from "styled-components";
import { Button } from "../../../../../../../base/buttons/button/index.js";
import { FlexMixin, FontMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../../../styles/common/mixins/logical.styled.js";
export const CounterButtonMobileWrapper = styled(Button).withConfig({
    displayName: "styled__CounterButtonMobileWrapper",
    componentId: "sc-b60e8079-0"
})`
	width: 37px;
	${FlexMixin({
    justify: 'center',
    align: 'center'
})}
	${BorderRadius({
    all: '50%'
})}
	${FontMixin({
    size: 'large'
})}
	padding: 0;
`;

//# sourceMappingURL=styled.js.map